import { type TrialAssociation } from '@modules/trials/types/TrialAssociation'
import { sortTrialImages } from './helpers'
import { MediaLibraryImage } from './MediaLibraryImage'

export const TrialMediaLibrary = ({ trial }: { trial: TrialAssociation }) => {
  if ((trial?.chartImages?.length ?? 0) === 0) {
    return null
  }

  const orderedImages = sortTrialImages(trial.chartImages)

  return (
    <div className='grid grid-cols-1 gap-4 md:grid-cols-4'>
      {orderedImages?.map((image) => (
        <MediaLibraryImage image={image} key={image.externalId} trial={trial} />
      ))}
    </div>
  )
}
